export default __webpack_public_path__ + "static/media/bg-secundario-1.9b47d3f1.gif";